// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mi-1";
export var messageSideRight = "_mi-2";
export var orderLookupBubbleContainer = "_mi-0";
export var submitButton = "_mi-3";